// extracted by mini-css-extract-plugin
module.exports = {"root":"_3s79r","followButtonTag":"HZIdx","followButton":"_1iFco","icon":"pxEw5"};